import Vue from 'vue'
import Router from 'vue-router'
import AppResidentLayout from '@/layouts/AppResidentLayout.vue'
import AppManagementLayout from '@/layouts/AppManagementLayout.vue'
import RequestMainPage from '@/pages/request/Main.vue'
import FinishPage from '@/pages/request/Finish.vue'
import ApprovePage from '@/pages/request/Approve.vue'
import GreenRoutePage from '@/pages/request/GreenRoute.vue'
import GreenRouteFormPage from '@/pages/request/GreenRouteForm.vue'
import RedRoutePage from '@/pages/request/RedRoute.vue'
import RedRouteWizardPage from '@/pages/request/RedRouteWizard.vue'
import RedRouteContinuePage from '@/pages/request/RedRouteContinue.vue'
import RedRouteBeforeContinuePage from '@/pages/request/RedRouteBeforeContinue.vue'
import ResidentApprovalPdfPage from '@/pages/request/ResidentApprovalPdf.vue'
import CompleteDetailsPage from '@/pages/request/CompleteDetails.vue'
import { AppConstants } from '@/core/Export'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: AppResidentLayout,
      meta: { requiresAuth: false, isManagement: false },
      children: [
        {
          path: '/',
          component: RequestMainPage,
          name: AppConstants.Routes.RequestMain,
        },
        {
          path: 'request/:requestId/:email/:authority/document/approval/view',
          component: ResidentApprovalPdfPage,
          name: AppConstants.Routes.ResidentApprovalPdf,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestApprovePage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/approve',
          component: ApprovePage,
          name: AppConstants.Routes.Approve,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestFinishApprovePage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/:requestNo/:year/finish',
          component: FinishPage,
          name: AppConstants.Routes.Finish,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestRouteGreenPage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/route/green',
          component: GreenRoutePage,
          name: AppConstants.Routes.GreenRoute,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestRouteGreenFormPage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/route/green/form',
          component: GreenRouteFormPage,
          name: AppConstants.Routes.GreenRouteForm,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestRouteRedPage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/route/red',
          component: RedRoutePage,
          name: AppConstants.Routes.RedRoute,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (
              appEnv.canViewRequestRouteRedPage &&
              appEnv.canViewRequestRouteRedQuestionsPage
            ) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/route/red/questions',
          component: RedRouteWizardPage,
          name: AppConstants.Routes.RedRouteQuestions,
        },
        {
          beforeEnter: (to, from, next) => {
            let appEnv = store.state.appEnv
            if (appEnv.canViewRequestContinuePage) {
              return next()
            } else {
              return next('/')
            }
          },
          path: 'request/route/red/continue',
          component: RedRouteContinuePage,
          name: AppConstants.Routes.RedRouteContinue,
        },
        {
          path: 'request/:requestNo/year/:year/route/red/before/continue',
          component: RedRouteBeforeContinuePage,
          name: AppConstants.Routes.RedRouteBeforeContinue,
        },
        {
          path: '/request/completeDetails/:email/:guid',
          component: CompleteDetailsPage,
          name: AppConstants.Routes.ResidentCompleteRequestDetails,
        },
      ],
    },
  ],
})
router.beforeEach((to, from, next) => {
  let appEnv = store.state.appEnv
  if(to.name == AppConstants.Routes.ResidentApprovalPdf){
    appEnv.authority = to.params.authority;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    
    if (!appEnv.Authenticated) {
      appEnv.Authenticated = false
      return next('/')
    } else {
      return next()
    }
  } else {
    return next()
  }
})

export default router
